












































import { Component, Vue, PropSync } from 'vue-property-decorator'
import MenusService from '@/service/MenusService'

@Component
export default class NaviComponent extends Vue {
  menusService = MenusService.instance

  @PropSync("drawer", { type: Boolean, default: false, required: true })
  syncDrawer!: boolean

 /**
   * 有効な業務メニューを取得
   */
  get menus() {
    return this.menusService.menus
  }

  /**
   * 有効なメニューを取得
   */
  get items() {
    return this.menusService.naviItems
  }
}
